import React from "react";
import { Container, Row, Col, Button, Image, Card } from "react-bootstrap";
import BannerDesktop from '../../../Assets/images/watches/tissot-watch-imgs/banner-desktop.jpg'
import BannerMobile from '../../../Assets/images/watches/tissot-watch-imgs/banner-mobile.jpg'
import tactile from '../../../Assets/images/watches/tissot-watch-imgs/tactile-and-connected.png'
import classic from '../../../Assets/images/watches/tissot-watch-imgs/classic.jpg'
import sport from '../../../Assets/images/watches/tissot-watch-imgs/sport.jpg'
import gift from '../../../Assets/images/watches/tissot-watch-imgs/gift-idea.jpg'
import pocketWatch from '../../../Assets/images/watches/tissot-watch-imgs/pocket-watch.jpg'
import { isMobileOnly } from "react-device-detect";
import Slider from "react-slick";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import '../../../Assets/css/tissotWatch.css'

const Tissot = () => {
    const history = useHistory();
        const settingTissotWatch = {
        dots: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };
  return (
    <div className='tissot_watch_page_section'>
       {/* Hero Section */}
      <div className="hero-section text-center text-white d-flex align-items-center justify-content-center position-relative">
   {    isMobileOnly ?<Image src={BannerMobile} alt="Banner" className="img-fluid w-100" /> :<Image src={BannerDesktop} alt="Banner" className="img-fluid w-100" />}
        <div className="ti_banner_text_box">
          <h1>Innovators by Tradition</h1>
          <p>Swiss precision and timeless elegance, crafted for every moment of your life.</p>
          <button className="ti_btn_white" onClick={() => history.push("/watches-list/Tissot") }>Shop Now</button>
        </div>
      </div>

      {/* Categories Section */}
      <Container fluid className="py-3 pb-sm-0 pb-md-3 py-lg-5 py-md-4">
        <Row>
                        <Col sm={12} md={12} lg={12} className="p-0">
                            <Slider {...settingTissotWatch}>
                                {[
                                    { id: 1, url:"#", img: tactile, title: "TACTICAL AND CONNECTED" },
                                    { id: 2, url:"#", img: classic, title: "CLASSIC" },
                                    { id: 3, url:"#", img: sport, title: "SPORT" },
                                ].map((item) => (
                                    <div className="mo_settingsNewArrivals_outer_box">
                                        <Card className="border-0 bg-transparent">
                                            <div className="ti_gift_img_box">

                                            <Card.Img variant="top" src={item.img} />
                                            </div>
                                            <Card.Body className="text-center pb-sm-0 pb-0">
                                                <h4>{item.title}</h4>
                                                <button className="mo_btn_explore"  onClick={() => history.push("/watches-list/Tissot") }>Explore Now</button>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                ))}

                            </Slider>
                        </Col>
                    </Row>
      </Container>

      {/* Gift Ideas Section */}
      <Container fluid className="pt-3 pt-sm-0 pt-md-3 pt-lg-3">
        <Row className="align-items-center mx-lg-4">
          <Col md={6} className="order-md-1 order-lg-1 order-2">
          <div className="ti_gift_text_box">
            <h3>Gift Ideas</h3>
            <p>
              Rise above the clamor of distractions. Like our watches,
your milestones and achievements deserve to be
commemorated. Make every single moment count
and commemorate special occasions with a timeless
Tissot watch from our selection. Give the gift of time.
            </p>
          </div>
          </Col>
          <Col md={6} className="pl-md-0 order-md-2 order-lg-2 order-1">
          <div className="ti_gift_img_box">
            <img
              src={gift}
              alt="Gift Ideas"
              className="img-fluid w-100"
            />
          </div>
          </Col>
        </Row>
      </Container>

      {/* Pocket Watches Section */}
      <Container fluid className="pb-lg-5 pb-sm-0 pb-md-4 ">
        <Row className="align-items-center mx-lg-4">    
          <Col md={6} className="pr-md-0">
           <div className="ti_gift_img_box">
            <img
              src={pocketWatch}
              alt="Pocket Watches"
              className="img-fluid w-100"
            />
           </div>
          </Col>
          <Col md={6}>
           <div className="ti_gift_text_box">
            <h3>Pocket Watches</h3>
            <p>
             Keeping traditions alive. Since 1853, Tissot has been
creating pocket watches. These incredible pieces of
craftsmanship are still manufactured today. Discover
our selection of pocket timepieces, to gift or to wear.
            </p>
           </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Tissot
